import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'components/ui';
import { HiOutlineInboxIn } from 'react-icons/hi';

const EmptyState = ({
  icon: Icon = HiOutlineInboxIn,
  iconSize = 64,
  title = 'No data found',
  description,
  action,
  className,
  compact = false
}) => {
  const containerClasses = classNames(
    'flex flex-col items-center justify-center text-center',
    compact ? 'py-8' : 'py-16',
    className
  );

  const iconClasses = classNames(
    'text-gray-300 dark:text-gray-600 mb-4',
    compact && 'mb-3'
  );

  const titleClasses = classNames(
    'font-bold text-gray-700 dark:text-gray-300',
    compact ? 'text-lg mb-1' : 'text-xl mb-2'
  );

  const descriptionClasses = classNames(
    'text-gray-500 dark:text-gray-400 max-w-md',
    compact ? 'text-sm mb-4' : 'text-base mb-6'
  );

  return (
    <div className={containerClasses}>
      <Icon size={compact ? iconSize * 0.75 : iconSize} className={iconClasses} />

      <h3 className={titleClasses}>{title}</h3>

      {description && (
        <p className={descriptionClasses}>{description}</p>
      )}

      {action && (
        <Button
          variant="solid"
          size={compact ? 'sm' : 'md'}
          onClick={action.onClick}
          icon={action.icon}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  /**
   * Icon component to display
   */
  icon: PropTypes.elementType,

  /**
   * Size of the icon in pixels
   */
  iconSize: PropTypes.number,

  /**
   * Main title text
   */
  title: PropTypes.string,

  /**
   * Description text (optional)
   */
  description: PropTypes.string,

  /**
   * Action button configuration
   */
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.node
  }),

  /**
   * Additional CSS classes
   */
  className: PropTypes.string,

  /**
   * Compact mode for smaller spaces
   */
  compact: PropTypes.bool
};

export default EmptyState;
